<template>
  <div class="recoveryPassword">
    <div class="title">
      <div class="recoveryPasswordTitle">
        <h1>{{ $t("authorization.passwordRecovery") }}</h1>
      </div>
      <div class="border"></div>
    </div>
    <form @submit.prevent="recovery()">
      <div class="recoverPasswordForm">
        <div class="column">
          <div class="row">
            <div class="eyes">
              <input
                @input="checkPassword()"
                :type="show.password ? 'text' : 'password'"
                v-model="initUser.password"
                :placeholder="$t('authorization.createNewPassword')"
                required
              />
              <div class="password-btn" @click="show.password = !show.password">
                <i class="fas fa-eye-slash" v-if="show.password"></i>
                <i class="fas fa-eye" v-if="!show.password"></i>
              </div>
            </div>
            <svg
              v-if="errors.password"
              width="30"
              height="28"
              viewBox="0 0 30 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M29.7137 24.1033L16.829 1.78645C16.4473 1.12521 15.7635 0.730469 15 0.730469C14.2365 0.730469 13.5527 1.12521 13.171 1.78645L0.286348 24.1033C-0.0954492 24.7645 -0.0954492 25.5541 0.286348 26.2152C0.668086 26.8765 1.35182 27.2712 2.11535 27.2712H27.8846C28.6482 27.2712 29.3319 26.8765 29.7137 26.2152C30.0954 25.5541 30.0954 24.7645 29.7137 24.1033ZM28.1895 25.3353C28.1516 25.401 28.0614 25.5113 27.8847 25.5113H2.11535C1.93852 25.5113 1.8484 25.4011 1.81055 25.3353C1.77264 25.2696 1.72213 25.1364 1.81055 24.9833L14.6951 2.66641C14.7836 2.5133 14.9241 2.49039 14.9999 2.49039C15.0759 2.49039 15.2164 2.51324 15.3047 2.66641L28.1895 24.9833C28.2779 25.1364 28.2274 25.2696 28.1895 25.3353Z"
                fill="#D34D4D"
              />
              <path
                d="M15.8803 8.73242H14.1203V18.119H15.8803V8.73242Z"
                fill="#D34D4D"
              />
              <path
                d="M14.9993 22.2256C15.6473 22.2256 16.1726 21.7003 16.1726 21.0522C16.1726 20.4042 15.6473 19.8789 14.9993 19.8789C14.3513 19.8789 13.8259 20.4042 13.8259 21.0522C13.8259 21.7003 14.3513 22.2256 14.9993 22.2256Z"
                fill="#D34D4D"
              />
            </svg>
          </div>
          <span v-if="errors?.password">
            {{ $t("authorization.showPassword") }}
          </span>
        </div>
        <div class="column">
          <div class="row">
            <div class="eyes">
              <input
                @input="checkPassword()"
                :type="show.confirmPasswordLog ? 'text' : 'password'"
                v-model="initUser.confirmPassword"
                :placeholder="$t('authorization.replyNewPassword')"
                required
              />
              <div
                class="password-btn"
                @click="show.confirmPasswordLog = !show.confirmPasswordLog"
              >
                <i class="fas fa-eye-slash" v-if="show.confirmPasswordLog"></i>
                <i class="fas fa-eye" v-if="!show.confirmPasswordLog"></i>
              </div>
            </div>
            <svg
              v-if="errors.confirmPassword"
              width="30"
              height="28"
              viewBox="0 0 30 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M29.7137 24.1033L16.829 1.78645C16.4473 1.12521 15.7635 0.730469 15 0.730469C14.2365 0.730469 13.5527 1.12521 13.171 1.78645L0.286348 24.1033C-0.0954492 24.7645 -0.0954492 25.5541 0.286348 26.2152C0.668086 26.8765 1.35182 27.2712 2.11535 27.2712H27.8846C28.6482 27.2712 29.3319 26.8765 29.7137 26.2152C30.0954 25.5541 30.0954 24.7645 29.7137 24.1033ZM28.1895 25.3353C28.1516 25.401 28.0614 25.5113 27.8847 25.5113H2.11535C1.93852 25.5113 1.8484 25.4011 1.81055 25.3353C1.77264 25.2696 1.72213 25.1364 1.81055 24.9833L14.6951 2.66641C14.7836 2.5133 14.9241 2.49039 14.9999 2.49039C15.0759 2.49039 15.2164 2.51324 15.3047 2.66641L28.1895 24.9833C28.2779 25.1364 28.2274 25.2696 28.1895 25.3353Z"
                fill="#D34D4D"
              />
              <path
                d="M15.8803 8.73242H14.1203V18.119H15.8803V8.73242Z"
                fill="#D34D4D"
              />
              <path
                d="M14.9993 22.2256C15.6473 22.2256 16.1726 21.7003 16.1726 21.0522C16.1726 20.4042 15.6473 19.8789 14.9993 19.8789C14.3513 19.8789 13.8259 20.4042 13.8259 21.0522C13.8259 21.7003 14.3513 22.2256 14.9993 22.2256Z"
                fill="#D34D4D"
              />
            </svg>
          </div>
          <span v-if="errors.confirmPassword">
            {{ $t("authorization.passwordMismatch") }}
          </span>
        </div>
        <button
          :disabled="!initUser.password || !initUser.confirmPassword"
          type="submit"
          class="clear"
        >
          {{ $t("authorization.saveChanges") }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { reactive } from "vue";
import { resetPwd } from "@/network/v1";
import { useRoute, useRouter } from "vue-router";
import { useLanguage } from "@/utils/language";

export default {
  setup() {
    const { i18nRoute } = useLanguage();
    const route = useRoute();
    const router = useRouter();

    const uid = route.query.uid;
    const token = route.query.token;

    let initial = true;

    const initUser = reactive({
      confirmPassword: "",
      password: "",
    });

    const errors = reactive({
      confirmPassword: false,
    });

    const show = reactive({
      password: false,
      confirmPassword: false,
    });

    const checkPassword = () => {
      if (initial) return;
      errors.passwordLog = !initUser.password || initUser.password.length === 0;
      errors.confirmPasswordLog =
        !initUser.confirmPassword || initUser.confirmPassword.length === 0;
    };

    const recovery = () => {
      initial = false;

      Object.keys(errors).forEach((key) => {
        delete errors[key];
      });
      checkPassword;

      const formData = new FormData();

      formData.append("password", initUser.confirmPassword);
      formData.append("uid", uid);
      formData.append("token", token);

      if (initUser.password !== initUser.confirmPassword) {
        return (errors.confirmPassword = true);
      } else {
        resetPwd(
          () => {
            if (!errors.password && !errors.confirmPassword) {
              router.push(i18nRoute({ name: "LogIn_Authorization" }));
            }
          },
          formData,
          async (res) => {
            const body = await res.json();
            for (const name in body) {
              errors[name] = body[name];
            }
            errors.confirmPassword = true;
          }
        );
      }
    };

    return {
      recovery,
      checkPassword,
      show,
      initUser,
      errors,
    };
  },
};
</script>

<style lang="scss" scoped>
.recoveryPassword {
  width: 40rem;
  // height: 31.25rem;
  padding-bottom: 4.188rem;
  .title {
    display: flex;
    flex-direction: column;
    align-items: center;
    .reserPasswordTitle {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      h1 {
        font-size: 1.875em;
        line-height: 2.198em;
        font-weight: 400;
        color: rgba(93, 93, 93, 1);
      }
    }
    .recoveryPasswordTitle {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      h1 {
        font-size: 1.875em;
        line-height: 2.198em;
        font-weight: 400;
        color: rgba(93, 93, 93, 1);
      }
    }
    .border {
      width: 90%;
      height: 0.125rem;
      background: rgba(230, 230, 230, 1);
    }
  }
  form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // margin-top: 3.438rem;
    .recoverPasswordForm {
      display: grid;
      grid-template-columns: auto;
      .column {
        display: flex;
        flex-direction: column;
        //   align-items: center;
        //   justify-self: start;
        margin-top: 45px;
        .row {
          display: flex;

          align-items: center;
          .eyes {
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: rgba(0, 0, 0, 0.03);
            width: 20.938rem;
            height: 3.375rem;
            padding: 0 20px;
            input {
              outline: none;
              background-color: transparent;
              width: 80%;
              font-weight: 300;
            }
            .password-btn {
              display: flex;
              i {
                color: rgba(128, 128, 128, 1);
                cursor: pointer;
              }
            }
          }
          svg {
            margin-left: 0.938rem;
          }
        }
        span {
          color: rgba(211, 77, 77, 1);
          font-size: 1em;
          line-height: 1.172em;
          margin-top: 0.313rem;
        }
      }
      .clear {
        width: 20rem;
        height: 3.625rem;
        border: 1px solid rgba(108, 143, 186, 1);
        outline: none;
        background-color: transparent;
        color: rgba(108, 143, 186, 1);
        margin-top: 3.125rem;
        cursor: pointer;
        margin-left: auto;
        margin-right: auto;
        font-size: 1.5em;
        line-height: 1.758em;
        font-weight: 400;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.4s ease;

        &:disabled {
          opacity: 0.5;
          transition: all 0.4s ease;
        }
      }
      &:nth-child(2) {
        margin-top: 45px;
      }
    }
  }
}

@media screen and (max-width: 1366px) {
  .recoveryPassword {
    width: 20.938rem;
    .title {
      .recoveryPasswordTitle {
        h1 {
          font-size: 1.5em;
          line-height: 1.758em;
          font-weight: 400;
          color: rgba(93, 93, 93, 1);
        }
      }
      .border {
        width: 95%;
      }
    }
    form {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      // margin-top: 3.438rem;
      .recoverPasswordForm {
        display: grid;
        grid-template-columns: auto;
        .column {
          display: flex;
          flex-direction: column;
          //   align-items: center;
          //   justify-self: start;
          margin-top: 2.188rem;
          .row {
            display: flex;
            width: 17.938rem;
            height: 2.813rem;
            align-items: center;
            .eyes {
              display: flex;
              align-items: center;
              justify-content: space-between;
              background-color: rgba(0, 0, 0, 0.03);

              input {
                outline: none;
                background-color: transparent;
                width: 80%;
                &::placeholder {
                  width: 100%;
                }
              }
            }
          }
          span {
            color: rgba(211, 77, 77, 1);
            font-size: 1em;
            line-height: 1.172em;
            margin-top: 0.313rem;
          }
        }
        .clear {
          width: 17.313rem;
          height: 3.625rem;
          border: 1px solid rgba(108, 143, 186, 1);
          outline: none;
          background-color: transparent;
          color: rgba(108, 143, 186, 1);
          margin-top: 3.125rem;
          cursor: pointer;
          margin-left: auto;
          margin-right: auto;
          font-size: 1.375em;
          line-height: 1.611em;
          font-weight: 400;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        &:nth-child(2) {
          margin-top: 45px;
        }
      }
    }
  }
}
</style>